import React, { useEffect } from 'react';
import {mostrarCajas} from '../../redux/reducers/cajasReducers';
import {FormControl, InputLabel} from "@mui/material";
import {SelectSmart} from "../CustomTextField";
import {formatPeso, hasPermissionTo, PERSMISOS, PERSMISOS_USUARIOS} from "../../helpers";
import Strings from "../../assets/strings"
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {IKeyValue} from "../../redux/types/Icommon";

type IProps = {
    required?: boolean
    disabled?: boolean
    allowNone?: boolean
    allowAll?: boolean
    margin?: "none" | "dense" | "normal" | undefined
    value?: number
    removeOption?: number
    name?: string
    label?: string
    all?: boolean
    onChange?: any
}

export default function SelectCaja(
    { value, name = "cajaId",label=Strings.caja, onChange,disabled=false,required=false, allowNone=true, allowAll=false, removeOption}:IProps) {


    const dispatch = useAppDispatch();
    const cajas = useAppSelector(state => state.cajas);


    useEffect(() => {
        if((hasPermissionTo(PERSMISOS.cajas) && hasPermissionTo(PERSMISOS_USUARIOS.cajas))) {
            dispatch(mostrarCajas({}));
        }
    }, [dispatch]);

    let { list = [] } = cajas;

    let opciones:IKeyValue[] = list.map(opc=>({
        key:opc.id,
        value:opc.descripcion +(hasPermissionTo(PERSMISOS.cajas) ?" - "+ formatPeso(opc.balance):"")
    }));
    if(allowAll) opciones.unshift({key:0,value:Strings.todo});
    if(allowNone) opciones.unshift({key:undefined,value:Strings.ninguna});
    if(removeOption){
        opciones = opciones.filter(opt=>opt.key !== removeOption)
    }
    if(!onChange){
        let selected = list.find(e=>e.id === value);
        return <>{selected?.descripcion ?? "-"}</>
    }
    return (
        <FormControl fullWidth required={required} disabled={disabled}>
            <InputLabel shrink>{label}</InputLabel>
            <SelectSmart
                value={value? value.toString():""}
                onChange={onChange}
                name={name}
                disabled={disabled}
                required={required}
                loading={cajas.status === "loading" }
                opciones={opciones}
            />
        </FormControl>

    );
}
